import React from "react";
import "css/main.css";
import "css/style.css";
import "external/fontawesome/css/all.css";
import { Outlet } from "react-router-dom";

function App() {
  return (
    <div>
      {/* This needs to exist to ahve the arrow up and down in react picker */}
      <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>
      <Outlet></Outlet>
    </div>
  );
}

export default App;
